(function () {

    'use strict';

    UserEditController.$inject = [
        '$scope',
        '$location',
        '$rootScope',
        '$routeParams',
        'growl',
        'errorService',
        'firmService',
        'userService',
        'roleService',
        'timezoneService'
    ];

    function UserEditController($scope, $location, $rootScope, $routeParams, growl, errorService, firmService, userService, roleService, timezoneService) {
        var vm = this;

        vm.firmId = $routeParams.firmId;
        vm.user = {};
        vm.canEditUser = roleService.canEditUser();

        vm.saveUser = saveUser;
        vm.cancel = cancel;

        vm.totalSpaceLimitInMegabytes = 1024;

        vm.timezones = [];
        vm.timezoneSelected = null;

        function saveUser(user, editUserForm) {
            // For showFormErrors directive.
            $scope.$broadcast('show-form-errors-check-validity');

            if (editUserForm.$valid) {
                vm.dataLoading = true;

                user.timezoneId = vm.timezoneSelected === null ? null : vm.timezoneSelected.id;

                if (!user.limitUploads)
                    delete user.totalSpaceLimitInMegabytes;

                userService.editUser(user)
                    .then(function () {

                        // If the user being edited is the current user, then set the timezone
                        if (user.id === $rootScope.userProfile.currentUser.userId) {
                            timezoneService.setTimezone(vm.timezoneSelected);
                        }

                        $location.url('/' + vm.firmId + '/users');
                    }, function (response) {
                        if (response === 'email-taken') {
                            growl.error('The email address already exists.');
                        } else if (response.data.message === 'unable-to-change-firm-administrator') {
                            growl.error('You cannot change the primary administrator\'s user type.');
                        } else if (response.data.message === 'unable-to-deactivate-firm-administrator') {
                            growl.error('You cannot deactivate the primary administrator.');
                        } else if (response.data.message === 'unable-to-deactivate-last-user-visible-for-upload') {
                            growl.error('You cannot deactivate last user with sharing option enabled.');
                        } else if (response.data.message === 'unable-to-change-last-user-visible-for-upload') {
                            growl.error('You cannot change user type to client of last user with sharing option enabled.');
                        } else {
                            growl.error('Something went wrong.  Please try again.');
                        }
                    })
                    .finally(function () {
                        vm.dataLoading = false;
                    });
            } else {
                return;
            }
        };

        function cancel() {
            $location.url('/' + vm.firmId + '/users');
        };

        function init() {
            var timezone;

            userService.getUser($routeParams.userId)
                .then(function (user) {
                    timezoneService.getTimezones()
                        .then(function (timezones) {
                            vm.timezones = timezones;
                            if (user.timezoneId !== null) {
                                timezone = vm.timezones[
                                    vm.timezones.map(function (e) { return e.id; }).indexOf(user.timezoneId)
                                ];
                                vm.timezoneSelected = timezone === undefined? null : timezone;
                            }
                        });

                    user.limitUploads = (user.totalSpaceLimitInMegabytes !== null);
                    vm.user = user;
                }, function (response) {
                    if (response.status === 404) {
                        $location.path('/notFound').replace();
                    } else {
                        errorService.handleError(response);
                    }
                })
                .finally(function () {
                    vm.dataLoading = false;
                });

            firmService.getStorageLimits()
                .then(function (firmStorageLimits) {
                    vm.totalSpaceLimitInMegabytes = firmStorageLimits.available / (1024 * 1024);
                });
        }

        init();
    }

    module.exports = UserEditController;
})();